import { useEffect, useState } from 'react';
import client from '../api/client';

function getSessionId() {
  let id = sessionStorage.getItem('_ep_sid');
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem('_ep_sid', id);
  }
  return id;
}

export function usePresence() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const sessionId = getSessionId();

    async function ping() {
      try {
        const res = await client.post('/presence/ping', { sessionId });
        setCount(res.data.count);
      } catch {}
    }

    ping();
    const interval = setInterval(ping, 20000);
    return () => clearInterval(interval);
  }, []);

  return count;
}
